import React from 'react';

import HeaderMain from '../../common/Header/HeaderMain';
import FooterMain from '../../common/Footer/FooterMain';
import BCLLoading from '../../../common/Loading/BCLLoading';
import { PREFERENCES_BASE_PATH } from '../../../../constants/paths';

const PreferencesContent = React.lazy(() => import(/* webpackChunkName: "PreferencesContent" */ '../PreferenceContent/PreferencesContent'));
class PreferencesMain extends React.Component {
  render() {
    return (
      <div className="preference-main">
        <HeaderMain configs={this.props.configs}/>
        <React.Suspense fallback={<BCLLoading />}>
          <PreferencesContent userDetails={this.props.userDetails.details} routePath={PREFERENCES_BASE_PATH} />
        </React.Suspense>
        <FooterMain configs={this.props.configs} translations={this.props.translations}/>
      </div>
    );
  }
}

export default PreferencesMain;
